export default __webpack_public_path__ + "wp-content/uploads/react/user-dashboard/media/logoIFN.0229e997.svg";